import React, { useState, useEffect } from 'react';
import { PageHeader, Btn } from '../../components/UI';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const NOTIF_ICONS = { payment_approved: '✅', payment_rejected: '❌', renewal_reminder: '⏰', auto_suspended: '🚫', widget_lead: '🔌', new_ticket: '🎫', suspended: '⏸', payment_received: '💰' };

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await api.get('/api/notifications');
    if (data.success) setNotifications(data.notifications);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/api/notifications/${id}/read`, {});
    setNotifications(ns => ns.map(n => n.id === id ? { ...n, is_read: true } : n));
  };

  const markAllRead = async () => {
    await api.put('/api/notifications/read-all', {});
    setNotifications(ns => ns.map(n => ({ ...n, is_read: true })));
    toast.success('All marked as read');
  };

  const unread = notifications.filter(n => !n.is_read).length;

  return (
    <div>
      <PageHeader title={`Notifications ${unread > 0 ? `(${unread} unread)` : ''}`}
        action={unread > 0 && <Btn variant="outline" size="sm" onClick={markAllRead}>✅ Mark All Read</Btn>}
      />

      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>Loading...</div>
        ) : notifications.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-muted)' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div>
            <div>No notifications yet 🎉</div>
          </div>
        ) : notifications.map(n => (
          <div key={n.id} onClick={() => !n.is_read && markRead(n.id)} style={{
            display: 'flex', alignItems: 'flex-start', gap: 14,
            padding: '16px 20px', borderBottom: '1px solid var(--border)',
            background: n.is_read ? 'transparent' : 'rgba(0,231,76,0.02)',
            cursor: n.is_read ? 'default' : 'pointer', transition: 'background 0.2s'
          }}>
            <div style={{ fontSize: 20, marginTop: 2, flexShrink: 0 }}>{NOTIF_ICONS[n.type] || '🔔'}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: n.is_read ? 400 : 600, fontSize: 14, marginBottom: 4 }}>{n.title}</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{n.message}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>{new Date(n.created_at).toLocaleString('en-IN')}</div>
            </div>
            {!n.is_read && <div style={{ width: 8, height: 8, background: 'var(--green)', borderRadius: '50%', marginTop: 6, flexShrink: 0 }} />}
          </div>
        ))}
      </div>
    </div>
  );
}